const copyToClipboard = (toastSuccessV2: any, copyText: string, successMsg?: string) => {
  navigator.clipboard.writeText(copyText)
  toastSuccessV2('Success', successMsg)
}

export default copyToClipboard
